import React, { useState } from 'react';
import { Circle } from 'react-konva';
import { PointProps } from '../types';

interface PointControlProps {
  id: string;
  x: number;
  y: number;
  onDragMove: (id: string, x: number, y: number) => void;
  onDragEnd?: () => void;
  isSelected: boolean;
}

const DraggablePoint: React.FC<PointControlProps> = ({
  x,
  y,
  onDragMove,
  onDragEnd,
  id,
  isSelected,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    if (onDragEnd) onDragEnd();
  };

  const pointSize = 10;

  // Enhanced styling for better visual appeal
  return (
    <Circle
      x={x}
      y={y}
      radius={pointSize / 2}
      fill={isSelected ? '#2563eb' : '#60a5fa'}
      stroke={isSelected ? '#1e40af' : '#3b82f6'}
      strokeWidth={1.5}
      draggable
      id={id}
      onDragStart={handleDragStart}
      onDragMove={(e) => {
        onDragMove(id, e.target.x(), e.target.y());
      }}
      onDragEnd={handleDragEnd}
      shadowColor="rgba(0, 0, 0, 0.3)"
      shadowBlur={isDragging ? 10 : 0}
      shadowOpacity={0.6}
      shadowOffset={{ x: 1, y: 1 }}
      perfectDrawEnabled
      onMouseEnter={(e) => {
        const stage = e.target.getStage();
        if (stage) stage.container().style.cursor = 'pointer';
      }}
      onMouseLeave={(e) => {
        const stage = e.target.getStage();
        if (stage) stage.container().style.cursor = 'default';
      }}
    />
  );
};

export default DraggablePoint;
